import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { InventoryNavigation } from './components/inventory/InventoryNavigation';
import { ScrollToTop } from './components/ScrollToTop';
import { CookieBanner } from './components/CookieBanner';
import { BackToTopButton } from './components/BackToTopButton';
// Inventory Pages
import { InventoryHomePage } from './pages/inventory/InventoryHomePage';
import { InventoryCategoryPage } from './pages/inventory/InventoryCategoryPage';
import { InventoryProductPage } from './pages/inventory/InventoryProductPage';
// Shared Pages
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { NotFoundPage } from './pages/NotFoundPage';
export function App() {
  return <HashRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white flex flex-col" data-id="element-2">
        <InventoryNavigation data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            {/* Inventory */}
            <Route path="/" element={<InventoryHomePage data-id="element-7" />} data-id="element-6" />
            {/* Changed from redirect to rendering the category page for "Browse All" */}
            <Route path="/inventory" element={<InventoryCategoryPage data-id="element-9" />} data-id="element-8" />
            <Route path="/inventory/:categorySlug" element={<InventoryCategoryPage data-id="element-11" />} data-id="element-10" />
            <Route path="/inventory/:categorySlug/:slug" element={<InventoryProductPage data-id="element-13" />} data-id="element-12" />

            {/* Shared Pages */}
            <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-17" />} data-id="element-16" />
            <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-19" />} data-id="element-18" />
            <Route path="/cookie-policy" element={<CookiePolicyPage data-id="element-21" />} data-id="element-20" />

            {/* Catch-all */}
            <Route path="*" element={<NotFoundPage data-id="element-23" />} data-id="element-22" />
          </Routes>
        </main>
        <CookieBanner data-id="element-24" />
        <BackToTopButton data-id="element-25" />
      </div>
    </HashRouter>;
}